var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLUE_500, Button, Card, RightChevronButtonIcon, Typography } from '@airtel/air-design-system';
import { View } from 'react-native';
import { getServiceCardWidgetStyles } from './ServiceCardWidgetStyles';
export var ServiceCardWidgetComponent = props => {
  var title = props.title,
    description = props.description,
    _props$iconColor = props.iconColor,
    iconColor = _props$iconColor === void 0 ? BLUE_500 : _props$iconColor,
    cta = props.cta,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    restProps = __rest(props, ["title", "description", "iconColor", "cta", "style"]);
  var serviceCardWidgetStyles = getServiceCardWidgetStyles();
  return _jsxs(Card, Object.assign({
    style: [serviceCardWidgetStyles.container, style]
  }, restProps, {
    children: [_jsxs(View, Object.assign({
      style: serviceCardWidgetStyles.upperSectionContainer
    }, {
      children: [_jsx(Typography, Object.assign({
        type: "title-single-line-sm"
      }, title)), _jsx(RightChevronButtonIcon, {
        fontSize: 16,
        color: iconColor
      })]
    })), _jsx(Typography, Object.assign({
      type: "body-para-md"
    }, description)), _jsx(View, Object.assign({
      style: serviceCardWidgetStyles.btnContainer
    }, {
      children: _jsx(Button, Object.assign({
        size: "sm",
        buttonType: "primary",
        version: "variable-width"
      }, cta))
    }))]
  }));
};
ServiceCardWidgetComponent.genericRendererKey = 'AirServiceCardWidget';